<template>
  <section>
    <el-col
      v-if="topButtonList != null && topButtonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item>
          <el-input
            v-model="filters.CompanyName"
            placeholder="企业工商登记名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="filters.ActivityId"
            placeholder="请输入领奖活动名称"
            :loading="loadingActivityName"
            filterable
            clearable
            remote
            reserve-keyword
            :remote-method="remoteMethod"
            @change="handleActName"
            style="width: 300px"
          >
            <el-option
              v-for="item in activityList"
              :key="item.ActivityId"
              :label="item.ActivityName"
              :value="item.ActivityId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-for="item in topButtonList" v-bind:key="item.id">
          <el-button
            v-prevent-re-click
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="tabData"
      border=""
      v-loading="listLoading"
      ref="table"
      style="width: 100%"
    >
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column
        prop="ActivityName"
        label="领奖活动名称"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="Number"
        label="领奖编号"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="CompanyName"
        label="企业工商登记名称"
        width="260"
      ></el-table-column>
      <el-table-column
        prop="USCI"
        label="企业组织机构代码"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="AwardName"
        label="奖项名称"
        width="200"
      ></el-table-column>
      <el-table-column prop="IsEnabled" label="是否开启" width="90">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.IsEnabled">是</el-tag>
          <el-tag type="warning" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="" v-if="tableButtonList.length > 0">
        <template slot-scope="scope">
          <span
            style="padding-left: 10px"
            v-for="item in tableButtonList"
            v-bind:key="item.id"
          >
            <el-button
              type="text"
              v-bind:key="item.id"
              v-prevent-re-click
              v-if="
                (!item.IsHide && item.name == '编辑') ||
                (!item.IsHide && item.name == '禁用' && scope.row.IsEnabled) ||
                (!item.IsHide && item.name == '启用' && !scope.row.IsEnabled)
              "
              @click="callFunc(item, scope.row)"
              >{{ item.name }}</el-button
            >
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filters.PageIndex"
        :page-size="filters.PageSize"
        :total="filters.total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!-- 新增 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addFormVisible"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleRuleFormClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="140px"
      >
        <el-form-item prop="ActivityId" label="领奖活动名称">
          <el-input disabled v-model="ruleForm.ActivityName"></el-input>
        </el-form-item>
        <el-form-item prop="Number" label="领奖编号">
          <el-input
            placeholder="领奖编号"
            v-model="ruleForm.Number"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="CompanyName" label="企业工商登记名称">
          <el-input
            placeholder="企业工商登记名称"
            v-model="ruleForm.CompanyName"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="USCI" label="企业组织机构代码">
          <el-input
            placeholder="企业组织机构代码"
            v-model="ruleForm.USCI"
            clearable
            maxlength="18"
          ></el-input>
        </el-form-item>
        <el-form-item prop="AwardName" label="奖项名称">
          <el-radio-group v-model="ruleForm.AwardName">
            <el-radio
              v-for="item in applyAwardTypeList"
              :label="item.Name"
              :key="item.Name"
              >{{ item.Name }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="IsEnabled" label="是否开启">
          <el-select v-model="ruleForm.IsEnabled" placeholder="请选择是否开启">
            <el-option label="否" :value="false"></el-option>
            <el-option label="是" :value="true"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提 交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 批量导入 -->
    <el-dialog
      title="批量导入"
      class="dialog-import"
      :visible.sync="dialogImport"
      :before-close="importHandleClose"
      width="50%"
    >
      <div class="importTop">
        <div><span>1</span>上传文件</div>
        <div><span>2</span>导入数据</div>
      </div>
      <div class="importList">
        <div class="bgIcon"></div>
        <div class="importList_R">
          <p class="font6">填写导入数据信息</p>
          <p class="font9">
            请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除
          </p>
          <p>
            <a href="#" @click="downloadTemp" class="fontG">下载模板</a>
          </p>
        </div>
      </div>
      <div class="importList">
        <div class="bgIcon bgIcon1"></div>
        <div class="importList_R">
          <p class="font6">上传</p>
          <p class="font9">
            文件后缀名必须为xls 或xlsx
            （即Excel格式），文件大小不得大于10M，最多支持导入3000条数据
          </p>
          <el-upload
            class="upload-demo"
            ref="upload"
            action=""
            :http-request="uploadAtteedee"
            :on-progress="importProgress"
            :before-upload="importBefore"
            :show-file-list="false"
            :file-list="fileList"
            :on-change="fileChange"
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          >
            <p>
              <a href="#" class="fontG">{{ importText }}</a>
            </p>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" @click="dialogImport = false">
        <el-button @click="dialogImport = false" class="hoverBtn1"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- 批量导入中 -->
    <el-dialog
      title="批量导入中"
      class="dialog-import"
      :visible.sync="dialogVisibleLoading"
      :before-close="importHandleClose"
      width="50%"
    >
      <div class="SuccessBox">
        <i class="el-icon-loading"></i>
        <h4 class="font6">数据导入中，请耐心等待....</h4>
      </div>
    </el-dialog>
    <!-- 导入失败 -->
    <el-dialog
      title="批量导入"
      class="dialog-import"
      :visible.sync="dialogVisibleFailure"
      :before-close="importFailureHandleClose"
      width="50%"
    >
      <div class="importTop">
        <div><span>1</span>上传文件</div>
        <div><span>2</span>导入数据</div>
      </div>
      <div class="importList">
        <div class="bgIcon3"><i class="el-icon-warning"></i></div>
        <div class="importList_R">
          <p class="font6">
            正常数量条数: <span class="fontG">{{ successCount }}条</span>
          </p>
          <p class="font6">
            异常数量条数: <span class="fontR">{{ errorCount }}条</span>
          </p>
        </div>
      </div>
      <div class="abnormalBox">
        <p class="title">异常提示：</p>
        <p v-for="item in errorMsg" :key="item">{{ item }}</p>
        <p>请检查无误后重新上传！</p>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
        @click="dialogVisibleFailure = false"
      >
        <el-button @click="importAgain" type="primary" class="fontF"
          >重新上传</el-button
        >
      </span>
    </el-dialog>
    <!-- 导入成功 -->
    <el-dialog
      title="批量导入"
      class="dialog-import"
      :visible.sync="dialogVisibleSuccess"
      :before-close="importSuccessHandleClose"
      width="50%"
    >
      <div class="SuccessBox">
        <i class="el-icon-success"></i>
        <h4 class="font6">批量导入完成</h4>
        <p class="font9">{{ improtMsg }}</p>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {
  getActivityList,
  importAwardCompany,
  getApplyAwardTypeList,
  AwardCompanyList,
  addOrUpdAwardCompany,
  AwardCompanyById,
  AwardCompanyEnable,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'

export default {
  data() {
    return {
      topButtonList: [],
      tableButtonList: [],
      filters: {
        CompanyName: '',
        ActivityId: '',
        ActivityName: '',
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      },
      tabData: [], // 列表绑定数据
      listLoading: false, // 列表加载效果
      activityList: [], // 适用活动
      loadingActivityName: false, // 适用活动 加载效果
      // 新增弹窗数据
      ruleForm: {
        ActivityId: '',
        ActivityName: '',
        Number: '',
        CompanyName: '',
        USCI: '',
        AwardName: '',
        IsEnabled: true,
        Id: 0,
      },
      applyAwardTypeList: [], //  奖项列表
      addFormVisible: false, // 新增、编辑弹窗
      dialogTitle: '', // 新增、编辑 弹窗的title
      dialogImport: false, // 批量导入
      importText: '上传文件',
      exportLink: `${process.env.VUE_APP_BASE_API}/api/awardCompany/template/export`,
      fileList: [],
      dialogVisibleLoading: false, // 导入中
      dialogVisibleSuccess: false,
      successCount: 0, // 导入成功数量
      improtMsg: '', // 导入成功消息
      dialogVisibleFailure: false,
      errorCount: 0, // 导入失败数量
      errorMsg: {}, // 导入异常提示
      rules: {
        ActivityId: [
          { required: true, message: '请输入领奖活动名称', trigger: 'blur' },
        ],
        Number: [
          { required: true, message: '请输入编号', trigger: 'blur' },
          {
            pattern: /^[0-9]*$/,
            message: '请输入正确的编号',
            trigger: 'blur',
          },
        ],
        CompanyName: [
          {
            required: true,
            message: '请输入企业工商登记名称',
            trigger: 'blur',
          },
          {
            min: 1,
            max: 50,
            message: '公司名称长度在1到50个字符',
            trigger: 'blur',
          },
        ],
        USCI: [
          {
            required: true,
            message: '请输入企业组织机构代码',
            trigger: 'blur',
          },
        ],
        AwardName: [
          { required: true, message: '请选择奖项名称', trigger: 'change' },
        ],
        IsEnabled: [
          { required: true, message: '请选择是否开启', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    // 按钮点击事件传值
    callFunc(item, row) {
      this.currentRow = row
      this[item.Func].apply(this, item)
    },

    // 查询
    handleQuery() {
      AwardCompanyList(this.filters).then((res) => {
        // console.log(res)
        this.tabData = res.data.response.data
        this.filters.total = res.data.response.dataCount
        this.filters.pageCount = res.data.response.pageCount
      })
    },
    // 导入
    handleImport() {
      if (!this.filters.ActivityId) {
        this.$message({
          message: '请先选择领奖活动名称',
          type: 'error',
        })
      } else {
        this.dialogImport = true
      }
    },
    //  新增
    handleAdd() {
      if (!this.filters.ActivityId) {
        this.$message({
          message: '请输入领奖活动名称',
          type: 'error',
        })
      } else {
        this.addFormVisible = true
        this.dialogTitle = '新增'
      }
    },
    // 编辑
    handleUpdate() {
      AwardCompanyById(this.currentRow.Id).then((res) => {
        if (res.data.success) {
          this.ruleForm = res.data.response
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
      this.addFormVisible = true
    },
    // 禁用
    handleDisable() {
      let param = {
        id: this.currentRow.Id,
        IsEnabled: false,
      }
      this.updateEnable(param) // 调用修改方法
    },
    // 启用
    handleEnable() {
      let param = {
        id: this.currentRow.Id,
        IsEnabled: true,
      }
      this.updateEnable(param) // 调用修改方法
    },

    // 关闭新增弹窗
    handleRuleFormClose() {
      this.addFormVisible = false
      this.$refs.ruleForm.resetFields()
      this.ruleForm.Id = 0
    },
    // 新增提交按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addOrUpdAwardCompany(this.ruleForm).then((res) => {
            // console.log(res)
            if (res.data.success) {
              this.filters.ActivityId = ''
              this.handleQuery()
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
              this.handleRuleFormClose()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }
          })
        } else {
          return false
        }
      })
    },

    /*
     * 批量导入
     */
    importHandleClose() {
      this.dialogImport = false
    },
    uploadAtteedee(param) {
      const form = new FormData()
      form.append('file', param.file)
      this.dialogVisibleLoading = true
      importAwardCompany({
        activityId: this.filters.ActivityId,
        form,
      })
        .then((response) => {
          console.log('---------------uploadAtteedee success response')
          console.log(response)
          param.onSuccess() // 上传成功的图片会显示绿色的对勾
          this.successCount = response.data.response.SuccessCount
          this.errorCount = response.data.response.ErrorCount
          this.dialogVisibleLoading = false
          if (response.data.success) {
            if (!response.data.response.Result) {
              this.dialogVisibleFailure = true
              this.errorMsg = response.data.response.ErrorMsg.split(';')
              return
            } else {
              this.dialogVisibleSuccess = true
              this.improtMsg = '导入成功'
              this.filters.ActivityId = ''
              this.handleQuery()
            }
          } else {
            this.errorMsg = response.data.response.ErrorMsg.split(';')
            this.dialogVisibleFailure = true
          }
        })
        .catch((response) => {
          console.log('uploadAtteedee fail response')
          console.log(response)
          param.onError()
          this.dialogVisibleLoading = false
          this.$message.error('导入异常，请联系开发人员')
        })
    },
    importProgress(event, file, fileList) {
      this.dialogVisibleLoading = true
      console.log(event, file, fileList)
    },
    importBefore(file) {
      if (
        file.type !== 'application/vnd.ms-excel' &&
        file.type !==
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        this.$message.error('请上传xls或xlsx格式的Excel')
        return false
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('上传的文件不得大于10M')
        return false
      }
    },
    fileChange(file) {
      this.$refs.upload.clearFiles() //清除文件对象
      this.fileList = [{ name: file.name, url: file.url }] // 重新手动赋值filstList， 免得自定义上传成功了, 而fileList并没有动态改变， 这样每次都是上传一个对象
    },
    downloadTemp() {
      window.open(this.exportLink)
    },
    // 导入失败
    importFailureHandleClose() {
      this.dialogVisibleFailure = false
    },
    // 导入成功
    importSuccessHandleClose() {
      this.dialogVisibleSuccess = false
      this.dialogImport = false
    },
    // 重新上传
    importAgain() {
      this.dialogVisibleLoading = false
      this.dialogImport = true
      this.importDisabled = false
      this.importText = '上传文件'
    },

    updateEnable(param) {
      AwardCompanyEnable(param).then((res) => {
        // console.log(res)
        if (res.data.success) {
          this.$message({
            message: '操作成功',
            type: 'success',
          })
          this.handleQuery()
        } else {
          this.$message({
            message: '操作失败',
            type: 'error',
          })
        }
      })
    },

    // 适用的活动
    remoteMethod(query) {
      if (query !== '') {
        this.loadingActivityName = true
        setTimeout(() => {
          getActivityList(query).then((res) => {
            // console.log(res)
            if (res.data.success) {
              this.activityList = res.data.response
              this.loadingActivityName = false
            }
          })
        }, 500)
      }
    },
    // 使用活动 选择事件，获取选择数据的值
    handleActName(val) {
      this.ruleForm.ActivityId = val
      this.ruleForm.ActivityName = val
        ? this.activityList.find((ele) => ele.ActivityId === val).ActivityName
        : ''
    },

    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },
  },
  mounted() {
    this.handleQuery()

    getApplyAwardTypeList().then((res) => {
      if (res.data.success) {
        this.applyAwardTypeList = res.data.response
      }
    })
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    let buttonList = getButtonList(this.$route.path, routers)
    this.topButtonList = buttonList.filter((item) => {
      return item.ButtonType === 0
    })
    this.tableButtonList = buttonList.filter((item) => {
      return item.ButtonType === 1
    })
  },
}
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.el-radio-group {
  line-height: 30px;
}
.dialog-import .importTop {
  display: flex;
  font-weight: bold;
  color: #666;
}

.dialog-import .importTop > div {
  margin-right: 30px;
}

.dialog-import .importTop > div span {
  display: inline-block;
  width: 40px;
  height: 40px;
  font-size: 30px;
  line-height: 40px;
  color: #fff;
  background: #30a53f;
  margin-right: 10px;
  text-align: center;
}

.dialog-import .importTop > div:last-child span {
  background: #cccccc;
}

.dialog-import .importList {
  display: flex;
  border: 1px solid #e9e9e9;
  align-items: center;
  height: 110px;
  margin-top: 20px;
}

.dialog-import .importList .bgIcon {
  background: url(../../assets/icon_download.png) no-repeat center #f5f5f5;
  height: 100%;
  width: 100px;
  line-height: 110px;
  background-size: 60px;
  margin-right: 15px;
  text-align: center;
}

.dialog-import .importList .bgIcon1 {
  background: url(../../assets/icon_upload.png) no-repeat center #f5f5f5;
  background-size: 60px;
}

.dialog-import .importList .bgIcon3 {
  background: #f5f5f5;
  font-size: 46px;
  color: #cccccc;
  width: 100px;
  margin-right: 15px;
  text-align: center;
  height: 100%;
  line-height: 110px;
}
.bgIcon3 i {
  font-size: 46px;
}

.dialog-import .importList .importList_R {
  font-size: 14px;
  flex: 1;
  padding-right: 10px;
}

.dialog-import .importList .importList_R > p {
  padding: 5px 0;
  margin: 0 0;
}
.abnormalBox {
  margin-top: 20px;
}

.upload-demo p {
  padding: 0 0;
  margin: 0 0;
}
.fontG {
  color: #30a53f;
}
.SuccessBox {
  text-align: center;
  margin: 30px 0;
}

.SuccessBox i {
  color: #30a53f;
  font-size: 100px;
}

.SuccessBox h4 {
  margin: 30px;
  font-size: 20px;
}

.SuccessBox1 {
  margin: 50px auto;
  width: 20%;
  padding: 0 20px;
  line-height: 50px;
  height: 50px;
  text-align: center;
  background: #30a53f;
}

.SuccessBox1 i {
  font-size: 30px;
  color: #fff;
  top: 5px;
  margin-right: 10px;
}

.SuccessBox1 a {
  display: block;
  width: 100%;
  height: 100%;
  color: #fff;
}
</style>
